<template>
  <v-row>
    <v-col cols="12" md="6" class="pb-0">
      <gg-text-field
        v-model="keyData.name"
        label="Key Name"
        name="Key Name"
        v-validate="'required'"
        :error-messages="errors.collect('Key Name')"
      />
    </v-col>
    <v-col cols="12" md="6" class="pb-0">
      <gg-input-label for="ppk-pass">Password</gg-input-label>
      <compact-password
        v-model="keyData.pass"
        outlined
        id="ppk-pass"
        show-strength
        cpanel-app="sshkey"
        with-generator
        data-vv-name="password"
        data-vv-as="Password"
        :error-messages="errors.collect('password')"
      />
    </v-col>
    <v-col cols="12" md="6" class="py-0">
      <gg-select
        :items="availableTypes"
        v-model="keyData.type"
        label="Key Type"
        name="Key Type"
        v-validate="'required'"
        :error-messages="errors.collect('Key Type')"
      />
    </v-col>
    <v-col cols="12" md="6" class="py-0">
      <gg-select
        :items="availableBits"
        v-model="keyData.bits"
        label="Key Size"
        name="Key Size"
        v-validate="'required'"
        :error-messages="errors.collect('Key Size')"
      />
    </v-col>
    <v-col cols="12" class="pt-0">
      <gg-btn
        :loading="loading"
        @click="generate"
      >
        Generate Key Pair
      </gg-btn>
    </v-col>
    <key-generated-modal
      :reason="reason"
      :opened="resultModalOpened"
      @close="resultModalClosed"
    />
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import CompactPassword from '@/components/Common/password/CompactPassword'
import KeyGeneratedModal from './KeyGeneratedModal'

export default {
  name: 'GeneratePublicKeyForm',
  components: {
    CompactPassword,
    KeyGeneratedModal,
  },
  data () {
    return {
      loading: false,
      keyData: {
        type: 'rsa',
        name: 'id_rsa',
        bits: 4096,
        pass: '',
      },
      availableBits: [1024, 2048, 4096],
      availableTypes: ['rsa', 'dsa'],
      reason: '',
      resultModalOpened: false,
    }
  },
  methods: {
    ...mapActions(['generateHostingSshKey', 'reportError', 'reportSuccess']),
    reset () {
      this.keyData.name = 'id_rsa'
      this.keyData.bits = 2048
      this.keyData.type = 'rsa'
      this.keyData.pass = ''
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    listenPassword (pass) {
      this.keyData.pass = pass
    },
    resultModalClosed () {
      this.reason = ''
      this.resultModalOpened = false
    },
    async generate () {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      this.loading = true
      try {
        const data = await this.generateHostingSshKey({
          ...this.keyData,
          _username: this.$route.query.user,
        })
        this.reason = data[0].reason
        // reset form and reload tables
        this.$emit('reload-tables', {
          privateTable: true,
          publicTable: true
        })
        this.reset()
        this.reportSuccess('Key Generation Complete!')
        // this.resultModalOpened = true
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
